<mat-divider *ngIf="hasMessages$ | async"></mat-divider>
<mc-system-message-list></mc-system-message-list>
